import { render } from "./App.vue?vue&type=template&id=17b153a6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=17b153a6&lang=sass"

import exportComponent from "/codebuild/output/src546414696/src/lima-web-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__